import Model from './BaseModel'
import axios from '@/plugins/axios'

export default class Research extends Model {
    resourceName() {
        return 'researches'
    }

    fields() {
        return ['id', 'name']
    }

    async send(research, customer) {
        return axios.post(this.resourceUrl(), {
            research_id: research.id,
            customer_id: customer.id,
        })
    }
}
